const { getProducts, getProgram } = require('../master-data')
const { listBatches: getBatches } = require('./../../../batch/api/batch-list')
const { getAllocatedStock } = require('../read/get-allocated-stock')
const tools = require('../../tools')
const createBulkSnapshots = require('../../../shipment/shipment-bulk-create-snapshots')
const get = require('lodash/get')

// Creating warehouse suborders creates snapshots that are suborders,
// moving to accepted use the same suborder ID as the warehouse suborder
// but still create a new snapshot doc for the REST API users to edit.
exports.acceptOrders = async function (state, {
  snapshots,
  programId,
  dryRun,
  noFunderSpecificLedger = false,
  date = new Date().toJSON(),
  api
}) {
  if (!snapshots.length) {
    return {
      acceptedSnapshotsCreated: 0,
      snapshots: [],
      shipmentSnapshots: []
    }
  }

  const [productsList, batchesList, stockResponse, program] = await Promise.all([
    getProducts(state, programId),
    getBatches(state),
    getAllocatedStock(state, {programId, date, locationId: snapshots[0].supplierId, includeLedger: true, noFunderSpecificLedger}),
    getProgram(state, programId)
  ])
  const {ledgerSDPUnits, funderId} = stockResponse
  // `managedOrders` on the program doc is the single source of truth for the
  // self-ordering behavior set:
  //  When set to false we use the facility self-ordering flow. Exact SKUs only, quantities
  //  entered in issue units, and the
  //  accepted snapshot ships as a single shipment.
  const managedOrders = get(program, 'managedOrders', true)
  const warehouseOrdersUseIssueUnits = !managedOrders
  const noAcceptedSnapshotSplit = !managedOrders
  const acceptedSnapshots = tools.acceptOrders({
    snapshots, user: state.user, ledger: ledgerSDPUnits, productsList, batchesList, date, warehouseOrdersUseIssueUnits, noAcceptedSnapshotSplit, managedOrders
  })

  // THe shipment.decorateShipmentSnapshotsWithResolvedPrices needs a pg connection to resolve the product price list
  // This `acceptOrders` method still gets called via the web app i.e via the web config `features.orders.onlineAdvanceGroup` flag
  // So we need to check if there is postgres access in order to run this piece of code or not
  const callShipmentPriceDecorateMethod = get(api, 'shipment.HAS_PG_ACCESS')
  let shipmentSnapshots
  if (callShipmentPriceDecorateMethod) {
    shipmentSnapshots = await api.shipment.decorateShipmentSnapshotsWithResolvedPrices(tools.createShipmentSnapshots({acceptedSnapshots, funderId, productsList}).map(snapshot => {
      return {...snapshot, removePaymentType: true}
    }))
  } else {
    shipmentSnapshots = tools.createShipmentSnapshots({acceptedSnapshots, funderId, productsList}).map(snapshot => {
      return {...snapshot, removePaymentType: true}
    })
  }

  if (dryRun) {
    return {
      acceptedSnapshotsCreated: acceptedSnapshots.length,
      snapshots: acceptedSnapshots,
      shipmentSnapshots
    }
  }

  await state.dal.order.bulkDocs(state, acceptedSnapshots)
  const shipments = await createBulkSnapshots(state, shipmentSnapshots)

  // TODO: this is a temporary response, see note in ordersFromSnapshotUpdates
  return {
    acceptedSnapshotsCreated: acceptedSnapshots.length,
    snapshots: acceptedSnapshots,
    shipments
  }
}
